module.exports = __webpack_public_path__ + "static/media/R-Smart MotorAI-E.952519d6.jpg";